import * as common from './common';
import * as Models from './models';

import * as Address from './address';
import * as Allergy from './allergy';
import * as Appointment from './previsit/appointment';
import * as Analyst from './analyst';
import * as Assistant from './assistant';
import * as Billing from './billing';
import * as Broadcast from './broadcast';
import * as Captcha from './captcha';
import * as CareGapFindings from './careGapFindings';
import * as CareProvider from './careProvider';
import * as ClinicalQuestion from './patient/order/clinicalQuestion';
import * as CopilotSession from './copilot/session';
import * as CopilotJob from './copilot/job';
import * as CrawlerApiConfig from './crawlerApi/config';
import * as DashboardEmbed from './dashboardEmbed';
import * as Diagnostics from './diagnostics';
import * as Document from './document';
import * as DocumentTemplate from './document/template';
import * as EhrInformation from './ehrInformation';
import * as EhrProviderInformation from './ehrProviderInformation';
import * as EhrSystem from './ehrSystem';
import * as EhrTimeSlot from './ehrTimeSlot';
import * as EhrTimeSlotBooking from './ehrTimeSlotBooking';
import * as EhrTwoFactor from './ehrTwoFactor';
import * as EmCode from './emCode';
import * as Encounter from './encounter';
import * as EncounterProblem from './encounterProblem';
import * as FeatureFlag from './featureFlag';
import * as Feed from './feed';
import * as FeedItem from './feedItems';
import * as Fingerprint from './fingerprint';
import * as FrontDeskDevice from './frontDeskDevice';
import * as Group from './group';
import * as HccFindings from './hccFindings';
import * as InsuranceCardOcrResult from './insuranceOcrResult';
import * as InsuranceProvider from './insuranceProvider';
import * as InsuranceRteRequest from './insuranceRteRequest';
import * as IpLocation from './iplocation';
import * as Log from './log';
import * as Maps from './maps';
import * as Medication from './medication';
import * as Mindtickle from './mindtickle';
import * as Note from './note';
import * as NoteMacro from './note/macro';
import * as NoteTranscript from './note/transcript';
import * as NoteTranscriptCommand from './note/transcriptCommand';
import * as NoteTranscriptSegment from './note/transcriptSegment';
import * as NoteTranscriptSegmentFieldMap from './note/transcriptSegmentFieldMap';
import * as NoticeOfAdmission from './noticeOfAdmission';
import * as NotificationContent from './notification/content';
import * as NotificationIntent from './notification/intent';
import * as NotificationSchedule from './notification/schedule';
import * as NotificationScheme from './notification/scheme';
import * as Orchestrator from './orchestrator';
import * as Order from './order';
import * as OrderMap from './orderMap';
import * as Organization from './organization';
import * as OrganizationAssistantConfiguration from './organization/assistant/configuration';
import * as OutreachSync from './outreachSync';
import * as Patient from './patient';
import * as PatientAdvisory from './patientAdvisory';
import * as PatientAdvisoryDocument from './patientAdvisoryDocument';
import * as PatientCareTeam from './patientCareTeam';
import * as PatientDocument from './patient/document';
import * as PatientFeedback from './feedback';
import * as PatientFinding from './patient/finding';
import * as PatientInformation from './patientInformation';
import * as PatientInsuranceInformation from './patientInsuranceInformation';
import * as PatientOrder from './patient/order';
import * as PatientSsn from './patientSsn';
import * as PatientUpload from './patientUpload';
import * as Payment from './payment';
import * as Payor from './payor';
import * as PayorClearinghouse from './payor/clearinghouse';
import * as Pharmacy from './pharmacy';
import * as Places from './places';
import * as Population from './population';
import * as Practice from './practice';
import * as PracticeGroup from './practiceGroup';
import * as PracticePreference from './practice/preference';
import * as PracticeTheme from './practice/theme';
import * as PredictDocument from './predict/document';
import * as PredictLabeling from './predict/labelingJobs';
import * as PredictNlp from './predict/nlp';
import * as PredictVision from './predict/vision';
import * as Previsit from './previsit';
import * as PrevisitConversion from './previsit/conversion';
import * as PrevisitDocumentTemplate from './previsit/documentTemplate';
import * as PrevisitLink from './previsit/link';
import * as PrevisitMessageRequest from './previsit/messageRequest';
import * as PrevisitMessageRequestLink from './previsit/messageRequestLink';
import * as PrevisitOrganization from './previsit/organization';
import * as PrevisitPatientInsuranceInformation from './previsit/patientInsuranceInformation';
import * as PrevisitPayor from './previsit/payor';
import * as PrevisitProvider from './previsit/provider';
import * as ProblemGroup from './problemGroup';
import * as Procedure from './procedure';
import * as Provider from './provider';
import * as ProviderNoteField from './providerNoteField';
import * as ProviderNoteSection from './providerNoteSection';
import * as ProviderProfile from './providerProfile';
import * as ProviderOrganizationPreference from './providerOrganizationPreference';
import * as ProviderTeam from './providerTeam';
import * as ProvisionalPatient from './provisionalPatient';
import * as RealTimeEligibility from './realTimeEligibility';
import * as Recording from './recording';
import * as RecordingSegment from './recordingSegment';
import * as RecommendationTemplate from './recommendationTemplate';
import * as ReportFeedback from './report/feedback';
import * as RescheduleEhrTimeSlot from './rescheduleEhrTimeSlot';
import * as RpaJob from './rpaJob';
import * as Saml from './saml';
import * as Scenario from './scenario';
import * as Search from './search';
import * as Segment from './segment';
import * as ServiceAccount from './serviceAccount';
import * as StandardMedication from './standardMedication';
import * as StandardNoteField from './standardNoteField';
import * as StandardNoteSection from './standardNoteSection';
import * as StripeAccount from './stripeAccount';
import * as NoteTemplate from './noteTemplate';
import * as Timeline from './timeline';
import * as TrainingSegments from './trainingSegments';
import * as Transcript from './transcript';
import * as User from './user';
import * as UserGroup from './user/group';
import * as UserPreferences from './user/preferences';
import * as Visit from './visit';
import * as VisitReason from './visitReason';
import * as Workflow from './workflow';
import * as WorkflowTest from './workflowTest';

export * from './models';
import Environment = Models.Common.Environment;
import Specialty = Models.Encounter.Specialty;
export { Environment, Specialty };
export { type AxiosProgressEvent } from 'axios';

// and make a Client class available, such that can easily configure which backend to call
export class Client {
  common: common.Common;
  StripeAccount: StripeAccount.API;
  Address: Address.API;
  Allergy: Allergy.API;
  Analyst: Analyst.API;
  Appointment: Appointment.API;
  Assistant: Assistant.API;
  Billing: Billing.API;
  Broadcast: Broadcast.API;
  Captcha: Captcha.API;
  CareGapFindings: CareGapFindings.API;
  CareProvider: CareProvider.API;
  ClinicalQuestion: ClinicalQuestion.API;
  CopilotSession: CopilotSession.API;
  CopilotJob: CopilotJob.API;
  CrawlerApiConfig: CrawlerApiConfig.API;
  DashboardEmbed: DashboardEmbed.API;
  Diagnostics: Diagnostics.API;
  Document: Document.API;
  DocumentTemplate: DocumentTemplate.API;
  EhrInformation: EhrInformation.API;
  EhrProviderInformation: EhrProviderInformation.API;
  EhrSystem: EhrSystem.API;
  EhrTimeSlot: EhrTimeSlot.API;
  EhrTimeSlotBooking: EhrTimeSlotBooking.API;
  EhrTwoFactor: EhrTwoFactor.API;
  EmCode: EmCode.API;
  Encounter: Encounter.API;
  EncounterProblem: EncounterProblem.API;
  FeatureFlag: FeatureFlag.API;
  Feed: Feed.API;
  FeedItem: FeedItem.API;
  Fingerprint: Fingerprint.API;
  FrontDeskDevice: FrontDeskDevice.API;
  Group: Group.API;
  HccFindings: HccFindings.API;
  InsuranceCardOcrResult: InsuranceCardOcrResult.API;
  InsuranceProvider: InsuranceProvider.API;
  InsuranceRteRequest: InsuranceRteRequest.API;
  IpLocation: IpLocation.API;
  Log: Log.API;
  Maps: Maps.API;
  Medication: Medication.API;
  Mindtickle: Mindtickle.API;
  Note: Note.API;
  NoteMacro: NoteMacro.API;
  NoteTranscript: NoteTranscript.API;
  NoteTranscriptCommand: NoteTranscriptCommand.API;
  NoteTranscriptSegment: NoteTranscriptSegment.API;
  NoteTranscriptSegmentFieldMap: NoteTranscriptSegmentFieldMap.API;
  NoticeOfAdmission: NoticeOfAdmission.API;
  NotificationContent: NotificationContent.API;
  NotificationIntent: NotificationIntent.API;
  NotificationSchedule: NotificationSchedule.API;
  NotificationScheme: NotificationScheme.API;
  Orchestrator: Orchestrator.API;
  Order: Order.API;
  OrderMap: OrderMap.API;
  Organization: Organization.API;
  OrganizationAssistantConfiguration: OrganizationAssistantConfiguration.API;
  OutreachSync: OutreachSync.API;
  Patient: Patient.API;
  PatientAdvisory: PatientAdvisory.API;
  PatientAdvisoryDocument: PatientAdvisoryDocument.API;
  PatientCareTeam: PatientCareTeam.API;
  PatientDocument: PatientDocument.API;
  PatientFeedback: PatientFeedback.API;
  PatientFinding: PatientFinding.API;
  PatientInformation: PatientInformation.API;
  PatientInsuranceInformation: PatientInsuranceInformation.API;
  PatientOrder: PatientOrder.API;
  PatientSsn: PatientSsn.API;
  PatientUpload: PatientUpload.API;
  Payment: Payment.API;
  Payor: Payor.API;
  PayorClearinghouse: PayorClearinghouse.API;
  Pharmacy: Pharmacy.API;
  Places: Places.API;
  Population: Population.API;
  Practice: Practice.API;
  PracticeGroup: PracticeGroup.API;
  PracticePreference: PracticePreference.API;
  PracticeTheme: PracticeTheme.API;
  PredictDocument: PredictDocument.API;
  PredictLabeling: PredictLabeling.API;
  PredictNlp: PredictNlp.API;
  PredictVision: PredictVision.API;
  Previsit: Previsit.API;
  PrevisitConversion: PrevisitConversion.API;
  PrevisitDocumentTemplate: PrevisitDocumentTemplate.API;
  PrevisitLink: PrevisitLink.API;
  PrevisitMessageRequest: PrevisitMessageRequest.API;
  PrevisitMessageRequestLink: PrevisitMessageRequestLink.API;
  PrevisitOrganization: PrevisitOrganization.API;
  PrevisitPatientInsuranceInformation: PrevisitPatientInsuranceInformation.API;
  PrevisitPayor: PrevisitPayor.API;
  PrevisitProvider: PrevisitProvider.API;
  ProblemGroup: ProblemGroup.API;
  Procedure: Procedure.API;
  Provider: Provider.API;
  ProviderNoteField: ProviderNoteField.API;
  ProviderNoteSection: ProviderNoteSection.API;
  ProviderOrganizationPreference: ProviderOrganizationPreference.API;
  ProviderProfile: ProviderProfile.API;
  ProviderTeam: ProviderTeam.API;
  ProvisionalPatient: ProvisionalPatient.API;
  RealTimeEligibility: RealTimeEligibility.API;
  Recording: Recording.API;
  RecordingSegment: RecordingSegment.API;
  RecommendationTemplate: RecommendationTemplate.API;
  ReportFeedback: ReportFeedback.API;
  RescheduleEhrTimeSlot: RescheduleEhrTimeSlot.API;
  RpaJob: RpaJob.API;
  Saml: Saml.API;
  Scenario: Scenario.API;
  Search: Search.API;
  Segment: Segment.API;
  ServiceAccount: ServiceAccount.API;
  StandardMedication: StandardMedication.API;
  StandardNoteField: StandardNoteField.API;
  StandardNoteSection: StandardNoteSection.API;
  NoteTemplate: NoteTemplate.API;
  Timeline: Timeline.API;
  TrainingSegments: TrainingSegments.API;
  Transcript: Transcript.API;
  User: User.API;
  UserGroup: UserGroup.API;
  UserPreferences: UserPreferences.API;
  Visit: Visit.API;
  VisitReason: VisitReason.API;
  Workflow: Workflow.API;
  WorkflowTest: WorkflowTest.API;

  constructor(
    env: Models.Common.Environment = Models.Common.Environment.Webprod,
  ) {
    this.common = new common.Common(env);
    this.StripeAccount = new StripeAccount.API(this.common);
    this.Address = new Address.API(this.common);
    this.Allergy = new Allergy.API(this.common);
    this.Analyst = new Analyst.API(this.common);
    this.Appointment = new Appointment.API(this.common);
    this.Assistant = new Assistant.API(this.common);
    this.Billing = new Billing.API(this.common);
    this.Broadcast = new Broadcast.API(this.common);
    this.Captcha = new Captcha.API(this.common);
    this.CareGapFindings = new CareGapFindings.API(this.common);
    this.CareProvider = new CareProvider.API(this.common);
    this.ClinicalQuestion = new ClinicalQuestion.API(this.common);
    this.CopilotSession = new CopilotSession.API(this.common);
    this.CopilotJob = new CopilotJob.API(this.common);
    this.CrawlerApiConfig = new CrawlerApiConfig.API(this.common);
    this.DashboardEmbed = new DashboardEmbed.API(this.common);
    this.Diagnostics = new Diagnostics.API(this.common);
    this.Document = new Document.API(this.common);
    this.DocumentTemplate = new DocumentTemplate.API(this.common);
    this.EhrInformation = new EhrInformation.API(this.common);
    this.EhrProviderInformation = new EhrProviderInformation.API(this.common);
    this.EhrSystem = new EhrSystem.API(this.common);
    this.EhrTimeSlot = new EhrTimeSlot.API(this.common);
    this.EhrTimeSlotBooking = new EhrTimeSlotBooking.API(this.common);
    this.EhrTwoFactor = new EhrTwoFactor.API(this.common);
    this.EmCode = new EmCode.API(this.common);
    this.Encounter = new Encounter.API(this.common);
    this.EncounterProblem = new EncounterProblem.API(this.common);
    this.FeatureFlag = new FeatureFlag.API(this.common);
    this.Feed = new Feed.API(this.common);
    this.FeedItem = new FeedItem.API(this.common);
    this.Fingerprint = new Fingerprint.API(this.common);
    this.Group = new Group.API(this.common);
    this.HccFindings = new HccFindings.API(this.common);
    this.InsuranceCardOcrResult = new InsuranceCardOcrResult.API(this.common);
    this.InsuranceProvider = new InsuranceProvider.API(this.common);
    this.InsuranceRteRequest = new InsuranceRteRequest.API(this.common);
    this.IpLocation = new IpLocation.API(this.common);
    this.Log = new Log.API(this.common);
    this.Maps = new Maps.API(this.common);
    this.Medication = new Medication.API(this.common);
    this.Mindtickle = new Mindtickle.API(this.common);
    this.Note = new Note.API(this.common);
    this.NoteMacro = new NoteMacro.API(this.common);
    this.NoteTranscript = new NoteTranscript.API(this.common);
    this.NoteTranscriptCommand = new NoteTranscriptCommand.API(this.common);
    this.NoteTranscriptSegment = new NoteTranscriptSegment.API(this.common);
    this.NoteTranscriptSegmentFieldMap = new NoteTranscriptSegmentFieldMap.API(
      this.common,
    );
    this.NoticeOfAdmission = new NoticeOfAdmission.API(this.common);
    this.NotificationContent = new NotificationContent.API(this.common);
    this.NotificationIntent = new NotificationIntent.API(this.common);
    this.NotificationSchedule = new NotificationSchedule.API(this.common);
    this.NotificationScheme = new NotificationScheme.API(this.common);
    this.Orchestrator = new Orchestrator.API(this.common);
    this.Order = new Order.API(this.common);
    this.OrderMap = new OrderMap.API(this.common);
    this.Organization = new Organization.API(this.common);
    this.OrganizationAssistantConfiguration =
      new OrganizationAssistantConfiguration.API(this.common);
    this.OutreachSync = new OutreachSync.API(this.common);
    this.Patient = new Patient.API(this.common);
    this.PatientAdvisory = new PatientAdvisory.API(this.common);
    this.PatientAdvisoryDocument = new PatientAdvisoryDocument.API(this.common);
    this.PatientCareTeam = new PatientCareTeam.API(this.common);
    this.PatientDocument = new PatientDocument.API(this.common);
    this.PatientFeedback = new PatientFeedback.API(this.common);
    this.PatientFinding = new PatientFinding.API(this.common);
    this.PatientInformation = new PatientInformation.API(this.common);
    this.PatientInsuranceInformation = new PatientInsuranceInformation.API(
      this.common,
    );
    this.PatientOrder = new PatientOrder.API(this.common);
    this.PatientSsn = new PatientSsn.API(this.common);
    this.PatientUpload = new PatientUpload.API(this.common);
    this.Payment = new Payment.API(this.common);
    this.Payor = new Payor.API(this.common);
    this.PayorClearinghouse = new PayorClearinghouse.API(this.common);
    this.Pharmacy = new Pharmacy.API(this.common);
    this.Places = new Places.API(this.common);
    this.Population = new Population.API(this.common);
    this.Practice = new Practice.API(this.common);
    this.FrontDeskDevice = new FrontDeskDevice.API(this.common);
    this.PracticeGroup = new PracticeGroup.API(this.common);
    this.PracticePreference = new PracticePreference.API(this.common);
    this.PracticeTheme = new PracticeTheme.API(this.common);
    this.PredictDocument = new PredictDocument.API(this.common);
    this.PredictLabeling = new PredictLabeling.API(this.common);
    this.PredictNlp = new PredictNlp.API(this.common);
    this.PredictVision = new PredictVision.API(this.common);
    this.Previsit = new Previsit.API(this.common);
    this.PrevisitConversion = new PrevisitConversion.API(this.common);
    this.PrevisitDocumentTemplate = new PrevisitDocumentTemplate.API(
      this.common,
    );
    this.PrevisitLink = new PrevisitLink.API(this.common);
    this.PrevisitMessageRequest = new PrevisitMessageRequest.API(this.common);
    this.PrevisitMessageRequestLink = new PrevisitMessageRequestLink.API(
      this.common,
    );
    this.PrevisitOrganization = new PrevisitOrganization.API(this.common);
    this.PrevisitPatientInsuranceInformation =
      new PrevisitPatientInsuranceInformation.API(this.common);
    this.PrevisitPayor = new PrevisitPayor.API(this.common);
    this.PrevisitProvider = new PrevisitProvider.API(this.common);
    this.ProblemGroup = new ProblemGroup.API(this.common);
    this.Procedure = new Procedure.API(this.common);
    this.Provider = new Provider.API(this.common);
    this.ProviderNoteField = new ProviderNoteField.API(this.common);
    this.ProviderNoteSection = new ProviderNoteSection.API(this.common);
    this.ProviderProfile = new ProviderProfile.API(this.common);
    this.ProviderOrganizationPreference =
      new ProviderOrganizationPreference.API(this.common);
    this.ProviderTeam = new ProviderTeam.API(this.common);
    this.ProvisionalPatient = new ProvisionalPatient.API(this.common);
    this.RealTimeEligibility = new RealTimeEligibility.API(this.common);
    this.Recording = new Recording.API(this.common);
    this.RecordingSegment = new RecordingSegment.API(this.common);
    this.RecommendationTemplate = new RecommendationTemplate.API(this.common);
    this.ReportFeedback = new ReportFeedback.API(this.common);
    this.RescheduleEhrTimeSlot = new RescheduleEhrTimeSlot.API(this.common);
    this.RpaJob = new RpaJob.API(this.common);
    this.Saml = new Saml.API(this.common);
    this.Scenario = new Scenario.API(this.common);
    this.Search = new Search.API(this.common);
    this.Segment = new Segment.API(this.common);
    this.ServiceAccount = new ServiceAccount.API(this.common);
    this.StandardMedication = new StandardMedication.API(this.common);
    this.StandardNoteField = new StandardNoteField.API(this.common);
    this.StandardNoteSection = new StandardNoteSection.API(this.common);
    this.NoteTemplate = new NoteTemplate.API(this.common);
    this.Timeline = new Timeline.API(this.common);
    this.TrainingSegments = new TrainingSegments.API(this.common);
    this.Transcript = new Transcript.API(this.common);
    this.User = new User.API(this.common);
    this.UserGroup = new UserGroup.API(this.common);
    this.UserPreferences = new UserPreferences.API(this.common);
    this.Visit = new Visit.API(this.common);
    this.VisitReason = new VisitReason.API(this.common);
    this.Workflow = new Workflow.API(this.common);
    this.WorkflowTest = new WorkflowTest.API(this.common);
  }
}
